module.exports = __webpack_public_path__ + "static/media/Wayfinder-Editor.3b27d4bb.mp4";